import { useState } from 'react';
import { requests } from '../../../services/external/APIs';
import { PayrollNoveltyFlow } from '../models/payrollNoveltyFlow';

export const usePayrollNoveltyFlows = () => {
    const [isLoading, setIsLoading] = useState(false);

    const getPayrollNoveltyFlow = async (id: string) => {
        setIsLoading(true);

        return requests
            .get('/dublin/api/v1/approval-flows/' + id)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const updatePayrollNoveltyFlow = async (
        id: string,
        model: PayrollNoveltyFlow
    ) => {
        setIsLoading(true);

        return requests
            .put(`/dublin/api/v1/approval-flows/${id}`, model)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const createPayrollNoveltyFlow = async (model: PayrollNoveltyFlow) => {
        setIsLoading(true);

        return requests
            .post(`/dublin/api/v1/approval-flows/`, model)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const deletePayrollNoveltyFlow = async (id: string) => {
        setIsLoading(true);

        return requests
            .delete(`/dublin/api/v1/approval-flows/${id}`)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const getUsersApproversFlow = async () => {
        setIsLoading(true);

        return requests
            .get(`/jerusalem/api/v1/users/overtime-approvers`)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    const getGroupsFlow = async () => {
        setIsLoading(true);

        return requests
            .get(`/dublin/api/v1/groups/payroll-novelties`)
            .then((res) => res)
            .catch((err) => err)
            .finally(() => setIsLoading(false));
    };

    return {
        getPayrollNoveltyFlow,
        isLoading,
        updatePayrollNoveltyFlow,
        deletePayrollNoveltyFlow,
        getGroupsFlow,
        getUsersApproversFlow,
        createPayrollNoveltyFlow,
    };
};
